<template>
  <div class="left-bar big-bar">
    <a class="one-bar" v-for="(menu, index) in menus" :class="{'active-bar': active_index === index}" href="javascript:;" @click="clickMenuF(menu.key, index)">
      <div class="bar-icon">
        <i class="iconfont" :class="menu.icon"></i>
      </div>
      <div class="bar-leabel big-bar-leabel">
        {{menu.leabel}}
      </div>
    </a>
    <div style="display: none">{{path}}</div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        hoverMenuIndex: -1,
        big_size: true,
        active_index: -1,
        menus: [{
          leabel: '数据导入',
          icon: 'icon-node-alone',
          active: true,
          key: 'ele_import'
        },
        {
          leabel: '参数设置',
          icon: 'icon-xunhuan',
          active: false,
          key: 'ele_case'
        },
        {
          leabel: '求解结果',
          icon: 'icon-shujudaochu',
          key: 'ele_result',
          active: false
        },
        {
          leabel: '方案对比',
          icon: 'icon-compare',
          key: 'ele_compare',
          active: false
        }]
      }
    },
    computed: {
      path: {
        get () {
          let path = this.$store.state.route.path
          let vm = this
          let routeName = this.$router.history.current.name
          this.menus.forEach(function (item, index) {
            if (item.key && item.key === routeName) {
              vm.active_index = index
            }
          })
          return path
        }
      }
    },
    methods: {
      clickMenuF (key, index) {
        if (key) {
          this.$router.push({ name: key })
          this.active_index = index
        }
      }
    },
    created () {
      let vm = this
      this.menus.forEach(function (item, index) {
        if (vm.$route.name === item.key) {
          vm.active_key = item.key
        }
      })
    }
  }
</script>

<style scoped lang="less">
  @import '../style/base.less';
  @left-bar-width: 4.5em;
  @left-bar-width-sm: 3em;
  @transition-time: 0.5s;
  .one-bar:hover {
    background-color: @bak-color-1;
    border-left: 0.31em solid @line-color;
    .right-menu {
      display: flex !important;
    }
  }
  .children-menu:hover {
    background-color: @bak-color-1;
  }
  .children-menu {
    flex: 1;
    width: 100%;
    font-size: 0.8em;
    color: #fff;
    height: 4em;
    margin: 0.5em 0;
    letter-spacing: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      margin-right: 0.5em;
    }
  }

  .right-menu {
    position: absolute;
    right: -7em;
    width: 7em;
    top: 0;
    flex-direction:column;
    display: none;
    background-color: @bak-color-2;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 0.5em; 
    border-bottom-right-radius: 0.5em; 
  }
  .sm-iconfont {
    .iconfont {
      font-size: 1.2em !important;
    }
    .icon-cheliangtiaodu {
      font-size: 1.6em  !important;
    }
  }
  .sm-bar-leabel {
    transform:rotateY(90deg);
    color:  @bak-color-2;
  }
  .big-bar-leabel {
    transform:rotateY(0deg);
  }
  .sm-bar {
    width: @left-bar-width-sm;
  }
  .big-bar {
    width: @left-bar-width;
  }
  .left-bar {
    transition: @transition-time;
    z-index: 5;
    min-height: 40em;
    display: flex;
    flex-direction: column;
    background-color: @bak-color-2;
  }

  .one-bar {
    position: relative;
    transition: 0.3s;
    display: flex;
    height: 7em;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color:@font-color-1;
    letter-spacing: 0.19em;
    .bar-icon  .icon-cheliangtiaodu {
      line-height: 1.2;
      font-size: 2.5em;
    }
    .iconfont {
      transition: 0.3s;
      line-height: 1.6;
      color: @font-color-icon;
      font-size: 1.2em;
    }
    .bar-leabel {
      margin-top: 0.5em;
      letter-spacing: 1px;
      transition: @transition-time;
      font-size: 0.8em;
      white-space:nowrap;
    }
  }
  .one-bar-s {
    transition: 0.3s;
    display: flex;
    height: 7em;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color:@font-color-1;
    letter-spacing: 0.19em;
    .iconfont {
      transition: 0.3s;
      line-height: 1.6;
      color: @font-color-icon;
      font-size: 1.2em;
    }
    .bar-leabel {
      transition: @transition-time;
      font-size: 0.8em;
      white-space:nowrap;
    }
  }
  .hide-bar {
    color: #999;
    .iconfont {
      color: #999;
    }
  }
  .active-bar {
    background-color: @bak-color-1;
    border-left: 0.31em solid @line-color;
  }

  .sm-bar-shou-btn {
    left: @left-bar-width-sm;
  }

  .big-bar-shou-btn {
    left: @left-bar-width;
  }
  .shou-btn-2 {
    z-index: 1000;
    color: #fff;
    transition: @transition-time;
    text-align: center;
    position: absolute;
    line-height: 1;
    width: 1.2em;
    top: 8em;
    background-color: @bak-color-2;
    padding: 0.3em 0;
    border-bottom-right-radius: 0.2em;
    border-top-right-radius: 0.2em;
    span {
      font-size: 0.8em;
    }
    i {
      font-size: 0.9em;
    }
  }

  .shou-btn {
    z-index: 1000;
    color: #fff;
    transition: @transition-time;
    text-align: center;
    position: absolute;
    line-height: 1;
    width: 1.2em;
    bottom: 2em;
    background-color: @bak-color-2;
    padding: 0.3em 0;
    border-bottom-right-radius: 0.2em;
    border-top-right-radius: 0.2em;
    span {
      font-size: 0.8em;
    }
    i {
      font-size: 0.9em;
    }
  }
</style>



// WEBPACK FOOTER //
// LeftBarEle.vue?4fd3deda